<button type="button" class="iconbtn" (click)="toggleKeyboard()">
  <mat-icon>keyboard</mat-icon>
</button>
